import { useEffect } from "react";

import type { ChatPageContent } from "~/hooks/useGlobalStore";
import useGlobalStore from "~/hooks/useGlobalStore";

/**
 * Registers the current content page's identity so the AI Tutor can connect
 * new chat threads to it. Skips registration while the id is not yet
 * available (fallback rendering) and clears it on unmount.
 */
const useChatPageContent = (content: ChatPageContent) => {
	const { setChatPageContent } = useGlobalStore();
	const { contentType, contentId, title } = content;

	useEffect(() => {
		if (!contentId) return;
		setChatPageContent({ contentType, contentId, title });
		return () => setChatPageContent(null);
	}, [contentType, contentId, title, setChatPageContent]);
};

export default useChatPageContent;
